export default {
    cantons: [],
};
